// fleet-generated: do not edit by hand
//
// Copied verbatim  : infra/fleet/artifacts/first-sync-gate/initial-sync-gate.ts
// Parameters       : none — below this header, identical across the fleet
// Destination      : packages/shared/src/powersync/initial-sync-gate.ts
//
// TO CHANGE THIS FILE, edit the canonical copy in infra and re-render. It
// changes for the whole fleet at once. Editing it here is reverted by the
// next render, and the guard in this repo goes red in the meantime:
//
//     cd ../infra && node fleet/fleet.ts render --repo meal-planner-app
//     node fleet/fleet.ts check --repo meal-planner-app
//
// The generator runs LOCALLY and is never invoked by CI. CI only verifies
// that what is committed matches the hash in .github/fleet-lock.json, which
// also records WHICH infra commit produced it. The commit is deliberately
// not repeated here: one value, one place — and stamping it into every file
// meant a one-line template edit rewrote four files in 28 repos.
/**
 * Which events the first-sync overlay feeds to `initialSyncMachine`, and in
 * which order — kept out of the component so it can be tested against the real
 * machine and the captured Tauri payload.
 *
 * The bug this encodes the fix for: the first-sync card reappeared for users
 * who had already synced. `USER_CHANGED` is what walks the machine from
 * `passthrough` into `connecting` (which shows the card), and it was sent as
 * soon as the session had a user, while the live status still had no streams
 * (every cold start under Tauri; see `offline-sync-status.ts`). Two rules:
 *
 *   1. Hold `USER_CHANGED` until the local database has answered whether it
 *      ever synced (`syncHistory !== "unknown"`).
 *   2. If it did, send a `STATUS_CHANGED` with `hasSynced: true` FIRST, so the
 *      machine goes `passthrough → synced` without ever visiting `connecting`.
 *      The opposite order flashes the card, and the overlay's minimum-visible
 *      latch then holds it on screen.
 */

/** Answer from `readEverSynced`, as the overlay tracks it. */
export type SyncHistory = "unknown" | "synced" | "never";

/** The slice of the overlay's status snapshot the machine events carry. */
export interface LiveSyncFlags {
  hasSynced: boolean;
  isDownloading: boolean;
  isConnected: boolean;
  isOnline: boolean;
}

export interface InitialSyncStatusEvent {
  type: "STATUS_CHANGED";
  hasSynced: boolean;
  isDownloading: boolean;
  isConnectedOrConnecting: boolean;
  isOnline: boolean;
}

export interface InitialSyncUserEvent {
  type: "USER_CHANGED";
  hasUser: boolean;
  inAuthGroup: boolean;
}

/** `STATUS_CHANGED` for the machine, with the persisted answer folded in. */
export function initialSyncStatusEvent(
  live: LiveSyncFlags,
  syncHistory: SyncHistory,
): InitialSyncStatusEvent {
  return {
    type: "STATUS_CHANGED",
    hasSynced: live.hasSynced || syncHistory === "synced",
    isDownloading: live.isDownloading,
    isConnectedOrConnecting: live.isConnected,
    isOnline: live.isOnline,
  };
}

/**
 * Events to send when the user, the route group or the persisted answer
 * changes. An empty list means "hold": send nothing yet.
 */
export function initialSyncUserEvents(input: {
  hasUser: boolean;
  inAuthGroup: boolean;
  syncHistory: SyncHistory;
  live: LiveSyncFlags;
}): (InitialSyncStatusEvent | InitialSyncUserEvent)[] {
  const { hasUser, inAuthGroup, syncHistory, live } = input;
  if (hasUser && syncHistory === "unknown") {
    return [];
  }
  const userEvent: InitialSyncUserEvent = { type: "USER_CHANGED", hasUser, inAuthGroup };
  if (syncHistory === "synced") {
    return [initialSyncStatusEvent(live, syncHistory), userEvent];
  }
  return [userEvent];
}
